<template>
  <div>
      <v-navigation-drawer
        v-model="drawer"
        class="px-6 pt-6 overflow-y-hidden pr-2"
        id="tag-drawer"
        width="550px"
        right
        fixed
        temporary
      >
        <div class="mb-5 fixed-drawer pr-8 pl-2">
          <v-row no-gutters>
            <v-col align="left" cols="auto">
              <h2
                class="
                  secondary--font
                  font-weight-600
                  float-left
                  text-capitalize
                "
              >
                {{ action }} Tag
              </h2>
            </v-col>
            <v-col align="right">
              <v-btn
                id="close-drawer"
                icon
                @click.stop="drawer = false"
                class="float-right"
              >
                <v-icon @click="drawer = false">mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="body-1">
              <span v-if="action == 'new'">
                Create tags so that you can mark tickets.
              </span>
              <span v-else> Edit tag with below details. </span>
            </v-col>
          </v-row>
          <v-row>
            <v-card elevation="0" width="100%">
              <v-form class="mt-5" v-model="valid" ref="tagForm">
                <v-card-text>
                  <v-text-field
                    id="textField"
                    label="Tag Name"
                    v-model="tagName"
                    outlined
                    class="required"
                    :rules="[(v) => !!v || 'Tag name is required']"
                    required
                  ></v-text-field>
                </v-card-text>
              </v-form>
            </v-card>
          </v-row>
        </div>
        <template v-slot:append>
          <div class="pa-2">
            <v-card-actions class="px-0 d-flex align-end">
              <v-btn
                id="cancel-drawer"
                class="font-weight-bold mb-4"
                outlined
                @click.stop="drawer = false"
                >Cancel</v-btn
              >

              <v-btn
                id="create-template"
                dense
                class="font-weight-bold mb-4"
                :dark="newName ? true : false"
                :disabled="newName ? false : true"
                @click="createTag()"
                :loading="loading"
                >Save</v-btn
              >
            </v-card-actions>
          </div>
        </template>
      </v-navigation-drawer>
  </div>
</template>

<script>

export default {
  name: 'tag-drawer',
  props:{
    name:{
      type: String,
    },
    id:{
      type: Number,
    },
    action:{
      type: String,
    },
  },
  data: ()=>{
    return {
      drawer: false,
      valid: true,
      loading: false,
      newName: null,
    }
  },

  watch:{
    drawer:{
      handler(newVal){      
        if(this.action==='new'){
          this.$refs.tagForm.reset();
        }else{
          this.newName = null;
        }
      }
    }
  },
  computed:{
    tagName:{
      get(){
        return this.name;
      },
      set(val){
        this.$emit('tag', val);
        this.newName = val;
      }
    }
  },

  methods:{
    createTag(){
      this.$emit('create');
    }
  }
}
</script>